<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item label="制单人">
                                <el-input style="width: 180px" v-model="makeBy" placeholder="双击选择制单人" @click.native="selUser">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="制单人部门">
                                <selectTree style="width: 180px" v-model="deptData.vModel" :tree-data="deptData.treeData" :isMulti="false"
                                            placeholder="请选择部门"></selectTree>
                            </el-form-item>
                            <el-form-item label="账单编号">
                                <el-input style="width: 180px" v-model="billNo" placeholder="请输入账单编号">
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="盘点仓号">
                                <el-input v-model="warehouseNo" placeholder="双击选择盘点仓库" readonly
                                          style="width: 180px"  @click.native="selWareHouse">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="盘点单位">
                                <selectTree style="width: 180px" v-model="units.vModel" :tree-data="units.treeData" :isMulti="false"
                                            placeholder="请选择盘点单位"></selectTree>
                            </el-form-item>
                            <el-form-item label="账单日期">
                                <el-date-picker
                                        v-model="billDate"
                                        size="medium"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div style="display: flex;margin-top: 5px">
                    <btnBar :btns="btnList" @doBtn="doBtn">
                    </btnBar>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>

        <selUser v-if="showUser"
                      :roleData="makeBy"
                      @closeDialog="closeDialog"
                      @checkRow="checkUser">
        </selUser>
        <selWareHouse v-if="showWareHouse"
                      :warehouseId="warehouseId"
                      @closeDialog="closeDialog"
                      @checkRow="checkWareHouse">
        </selWareHouse>
    </div>
</template>

<script>
    import btnBar from '@/components/tools/toolBar/btnBar'
    import selectTree from '@/components/tools/tree/selectTree'
    import selUser from '@/components/system/usermanage/userSelect/single'

    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
            btnBar, selectTree,selUser
        },
        data() {
            return {
                btnList: [],
                searBarHeight: 70,

                warehouseNo:"",
                warehouseId: "",
                showWareHouse: false,

                deptData: {
                    vModel: {
                        id: "",
                        name: ""
                    },
                    treeData: [],
                },
                units: {
                    vModel: {
                        id: "",
                        name: ""
                    },
                    treeData: [],
                },

                makeBy:"",
                showUser:false,

                billNo:"",
                billDate:[],
                projectId:"",
                projectName:"",
            }
        },
        async mounted() {
            this.$emit('update:loading', true);

            await this.getDepartmentTree();
            if (this.menuId)
                await this.getBtnList();

            this.$emit('update:loading', false);
        },
        methods: {
            selWareHouse() {
                this.showWareHouse = true;
            },
            checkWareHouse(row) {
                this.warehouseId = row.warehouseId;
                this.warehouseNo = row.warehouseNo;
                this.showWareHouse = false;
            },
            selUser(){
                this.showUser = true;
            },
            closeDialog() {
                this.showUser = false;
                this.showWareHouse = false;
            },
            checkUser(row) {
                this.makeBy = row.loginName;
                this.showUser = false;
            },
            async getDepartmentTree() {
                let param = {
                    url: "/department/listZTree",
                    param: {}
                }
                const data = await this.$store.dispatch('pubMethod', param)
                const retData = data.data.jsonStr;
                this.deptData.treeData = [{id: "", name: ""}].concat(retData)
                this.units.treeData = [{id: "", name: ""}].concat(retData)
            },
            async getBtnList() {
                this.$emit('update:loading', true);
                let param = {
                    url: "/systembutton/findByMenuId",
                    param: {
                        menuId: this.menuId,
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)

                if (data.infoCode == "0") {
                    this.btnList = data.data;
                }
                this.$emit('update:loading', false);
            },
            search() {
                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }
                let searchData = {
                    startDate:startDate,
                    endDate:endDate,
                    billNo:this.billNo,
                    makeBy:this.makeBy,
                    departmentIdUser:this.deptData.vModel.id,
                    departmentId:this.units.vModel.id,
                    warehouseNo:this.warehouseNo,
                }
                this.$emit('search',searchData);
            },
            doBtn(type) {
                this.$emit('doBtn', type)
            },
        }
    }
</script>

